import { Action } from '@/_core/fluxstore/types';
import { StorymapState, ViewType } from '../types';
import { useStorymapStore } from '../useModule';
import { allCards, getCardById } from '../use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class CutCard extends Action<StorymapState> {
    public static ACTION_TYPE = 'CutCard';

    public constructor(public cardId: string) {
        super(CutCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState): Promise<boolean> => {
    if (state.currentViewType === ViewType.Tracking) {
        return false;
    }

    return true;
};

const reducer = (state: StorymapState, action: CutCard): void => {
    const card = getCardById(action.cardId);
    allCards.value.forEach((x) => {
        x.isCopied = false;
        x.isCut = false;
    });
    card.isCut = true;
};

//@ts-ignore
registerMiddleware(CutCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(CutCard.ACTION_TYPE, reducer);
